import { render, staticRenderFns } from "./Optometria.vue?vue&type=template&id=4215495b"
import script from "./Optometria.vue?vue&type=script&lang=js"
export * from "./Optometria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports